import React from "react";
import { ElementType, ElementViewProps, EmbedSettings } from "@/shared/types";
import { ElementPlaceholder } from "@/shared/Components/ElementPlaceholder/ElementPlaceholder";

export interface EmbedViewProps extends ElementViewProps {}

export const EmbedView: React.FC<EmbedViewProps> = ({ element }) => {
  const embedSettings = element?.settings as EmbedSettings;
  const embedCode = embedSettings?.code || "";
  const [isError, setIsError] = React.useState<boolean>(false);

  const embedContainerRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!embedCode) return;

    try {
      const parsedHTML = document
        .createRange()
        .createContextualFragment(embedCode);

      if (embedContainerRef?.current) {
        // Clear previous content before appending
        embedContainerRef.current.innerHTML = "";
        embedContainerRef.current.appendChild(parsedHTML);
      }
    } catch (_error) {
      setIsError(true);
    }
  }, [embedCode]);

  return (
    <div
      id={element?.id}
      data-test="EmbedView"
      style={{ width: "100%", height: "100%", overflow: "hidden" }}
    >
      {embedCode && !isError ? (
        <>
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          <style>{`
          .iframeContainer {
            position: relative;
            width: 100%;
            padding-top: 56.25%;
            height: 0;
            iframe {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border: none;
              }
          }
          `}</style>
          <div
            ref={embedContainerRef}
            className={embedCode.includes("<iframe") ? "iframeContainer" : ""}
          />
        </>
      ) : (
        <ElementPlaceholder elementType={ElementType.Embed} />
      )}
    </div>
  );
};
